import React from 'react';
import CommentIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import FavoriteIcon from '@mui/icons-material/FavoriteBorder';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';

export default function PostAction(){
	return(
		<>
				<div style={{ display: "flex", justifyContent: "space-between", }}>
					<CommentIcon />
					<FavoriteIcon />
					<ShareRoundedIcon />
				</div>
			<hr />
		</>
	);
}